import { CSSObject, Theme } from '@mui/material';

export const missingFieldScrollMargin = (theme: Theme): CSSObject => ({
  scrollMarginTop: 80,

  [theme.breakpoints.down('md')]: {
    scrollMarginTop: 144,
  },
});

export const missingHighlightRing: CSSObject = {
  position: 'relative',

  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: 6,
    boxShadow: 'inset 0 0 0 1px #CC3300',
    pointerEvents: 'none',
  },
  '&:first-of-type::after': {
    top: -12,
  },
  '&:last-of-type::after': {
    bottom: -12,
  },
};

export const nonGatedAddButtonSx = (theme: Theme) => ({
  ...(theme.nonGated && {
    background: '#F5F5F5 !important',
    color: '#000000 !important',
    border: '1px solid #EFEFEF',
    borderRadius: '6px !important',
    width: 37,
    height: 37,
    minWidth: 37,
    minHeight: 37,
    maxWidth: 37,
    maxHeight: 37,
    padding: 0,
    flexShrink: 0,
    alignSelf: 'flex-end',
    boxShadow: 'none',
    '& .MuiSvgIcon-root': { fontSize: 19 },
    '&:hover': { background: '#EFEFEF !important' },
    '&.Mui-disabled, &:disabled': {
      background: '#F5F5F5 !important',
      color: '#000000 !important',
      opacity: 0.4,
    },
  }),
});

export const nonGatedFieldFlexSx = (
  theme: Theme,
  flex: string,
  minWidth: string,
  maxWidth: string | number = 'none'
) => ({
  [theme.breakpoints.up('sm')]: {
    ...(theme.nonGated && { flex, minWidth, maxWidth }),
  },
});
